exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge[data-v-0814f80b] {\n  border-radius: 10rem;\n  border: none;\n  font-weight: normal;\n}\n.badge.success[data-v-0814f80b] {\n  background-color: lightgrey;\n}\n.badge .icon.success[data-v-0814f80b] {\n  color: #801977;\n}\n.badge .badge-text[data-v-0814f80b] {\n  font-size: 1.7em !important;\n  color: black;\n  overflow-wrap: break-word;\n}", ""]);

// exports
